export function generateErrorId(length = 40): string {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const bytes = new Uint8Array(length);

    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        crypto.getRandomValues(bytes);
    } else {
        for (let i = 0; i < length; i++) {
            bytes[i] = Math.floor(Math.random() * 256);
        }
    }

    return Array.from(bytes, (byte) => chars[byte % chars.length]).join('');
}

export function extractErrorId(error: unknown): string | undefined {
    const axiosError = error as {
        response?: {
            headers?: Record<string, string | undefined>;
            data?: {
                requestId?: string;
                errorId?: string;
                id?: string;
            };
        };
    };

    const headers = axiosError.response?.headers;
    const data = axiosError.response?.data;

    return (
        headers?.['x-request-id'] ||
        headers?.['x-correlation-id'] ||
        data?.requestId ||
        data?.errorId ||
        (typeof data?.id === 'string' ? data.id : undefined)
    );
}
